"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by mariam.melkonyan on 8/18/17.
 */
var ChartSortType;
(function (ChartSortType) {
    ChartSortType[ChartSortType["TIME"] = 0] = "TIME";
    ChartSortType[ChartSortType["VALUES_ASCENDING"] = 1] = "VALUES_ASCENDING";
    ChartSortType[ChartSortType["VALUES_DESCENDING"] = 2] = "VALUES_DESCENDING";
    ChartSortType[ChartSortType["CATEGORY_ASCENDING"] = 3] = "CATEGORY_ASCENDING";
    ChartSortType[ChartSortType["CATEGORY_DESCENDING"] = 4] = "CATEGORY_DESCENDING";
})(ChartSortType = exports.ChartSortType || (exports.ChartSortType = {}));
//# sourceMappingURL=chart-sort-type.model.js.map